import { S3_IMAGES_URL } from '../../../constants';

export const HOTELS_CARDS_DATA = [
  {
    id: 1,
    src: `${S3_IMAGES_URL}book_stays_block/hotel_image_1.webp`,
    rating: '9.9',
    reviews: 'Excellent',
    width: '440px',
    height: '320px',
    style: { borderRadius: '32px' },
  },
  {
    id: 2,
    src: `${S3_IMAGES_URL}book_stays_block/hotel_image_2.webp`,
    rating: '9.2',
    reviews: 'Perfect',
    width: '220px',
    height: '160px',
    style: { transform: 'scale(0.7)', borderRadius: '16px' },
    ratingPosition: { bottom: '6px', left: '2px' },
    heartIconPosition: { top: '12px', right: '12px' },
  },
  {
    id: 3,
    src: `${S3_IMAGES_URL}book_stays_block/hotel_image_3.webp`,
    rating: '9.5',
    reviews: 'Excellent',
    width: '220px',
    height: '160px',
    style: { transform: 'scale(0.7)', borderRadius: '16px' },
    ratingPosition: { bottom: '6px', left: '2px' },
    heartIconPosition: { top: '12px', right: '12px' },
  },
  {
    id: 4,
    src: `${S3_IMAGES_URL}book_stays_block/hotel_image_4.webp`,
    rating: '9.1',
    reviews: 'Perfect',
    width: '167px',
    height: '122px',
    style: { transform: 'scale(0.55)', borderRadius: '12px' },
    ratingPosition: { bottom: '10px', left: '-6%' },
    heartIconPosition: { top: '10px', right: '10px' },
  },
  {
    id: 5,
    src: `${S3_IMAGES_URL}book_stays_block/hotel_image_5.webp`,
    rating: '9.7',
    reviews: 'Excellent',
    width: '167px',
    height: '122px',
    style: { transform: 'scale(0.55)', borderRadius: '12px' },
    ratingPosition: { bottom: '10px', left: '-6%' },
    heartIconPosition: { top: '10px', right: '10px' },
  },
];
